'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.pow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/pow.js
// module id = 725
// module chunks = 0